import React from "react";
import styled from "styled-components";
import OutlineButton from "../../../../../../../components/OutlineButton";
const Item = ({ label, desc }) => {
  return (
    <Container>
      <Value>{label}</Value>
      <Description>
      {desc}
      </Description>
      <ButtonContainer>
        <OutlineButton label={label === "Staking" ? "Stake" : "Bond"} />
      </ButtonContainer>
    </Container>
  );
};

export default Item;

const ButtonContainer = styled.div`
  width: 100px;
  margin-top: 30px;
`;
const Container = styled.div`
  text-align: left;
  flex: 1;
  background-color: #1b1f24;
  padding: 60px 30px;
`;
const Description = styled.div`
  color: #9ea0a4;
  font-size: 18px;
  line-height: 35px;
  margin-top: 20px;
`;
const Value = styled.div`
  color: white;
  font-size: 27px;
  font-weight: 700;
  margin-bottom: 5px;
`;
